const data = [
  {
    heading: 'Common Terms (For Online & Offline Students):',
  },

  {
    heading: 'Recording Policy',
    points: (
      <ul>
        The Institute retains all rights to record the sessions for their
        internal usage & quality purposes. These recordings are exclusively
        intended for the Institute’s use, and the data is securely stored to
        reasonably safeguard it against misuse, loss, and unauthorized access,
        modification, or disclosure. Please note that students are kindly
        requested not to make their own recordings of these live sessions. As
        per our policy, the recordings will not be available to the students.
      </ul>
    ),
  },
  {
    heading: 'Photography and Videography Policy',
    points: (
      <ul>
        As part of our ongoing commitment to promoting the practice of yoga and
        sharing the positive experiences of our students, we may capture
        photographs or videos for internal usage, promotional materials, and our
        social media platforms. However, if you prefer not to be photographed or
        video graphed, kindly inform your course coordinator at the time of the
        admission.
      </ul>
    ),
  },
  {
    heading: 'No Refund Policy',
    points: (
      <ul>
        The Yoga Institute has no refund policy for all its programmes. The only
        exception to this policy is in the event of a programme cancelled by the
        institute. In such cases, the student/participant will be offered a
        credit that can be used for any other programme or a refund of the event
        fee.
      </ul>
    ),
  },
  {
    heading: 'Age Eligibility',
    points: (
      <ul>
        <li>Teacher training course</li>
        The Teacher Training Course is open to individuals aged 18 years and
        above.
        <li>7-Days Health Camp and 21-Days Better Living Course:</li>
        To enrol in the 7-days Health Camp and 21-days Better Living Course,
        candidates must be aged 16 years and above.
        <li>Specialized Camps and Workshops:</li>
        Specialized camps and workshops, such as those focused on diabetes,
        pregnancy, and other specific conditions, are designed exclusively for
        individuals experiencing those conditions. Enrolment in these
        specialized programs is limited to individuals who meet the specific
        condition’s criteria.
      </ul>
    ),
  },
  {
    heading: 'Course Fee Updates',
    points: (
      <ul>
        <li>
          The course fees are subject to change, and any adjustments will be
          promptly updated on our website. If you have any further inquiries or
          require additional information, please do not hesitate to reach out to
          us at info@theyogainstitute.org.
        </li>
      </ul>
    ),
  },
  {
    heading: 'Attendance Criteria for All Certification Courses',
    points: (
      <ul>
        <li>
          Attendance of 80% for all the certification courses is mandatory
        </li>
      </ul>
    ),
  },
  {
    heading: 'Leave Request Policy',
    points: (
      <ul>
        <li>
          Should you foresee the necessity to request leave during any
          certification course, we kindly request that you provide advance
          notification to the course coordinator. If you are enrolled in any
          other course apart from the certification courses, kindly give a prior
          notice to the coordinator. Kindly note that your leave period will not
          be extended
        </li>
      </ul>
    ),
  },
  {
    heading: 'Dress Code',
    points: (
      <ul>
        <li>
          Students are kindly requested to adhere to the Institute’s dress code
          by opting for comfortable and modest attire. Please refrain from
          wearing shorts above the knees, narrow sleeveless tops and t-shirts,
          capris, tank tops, low-cut shirts.
        </li>
      </ul>
    ),
  },
  {
    heading: 'Communication Guidelines',
    points: (
      <ul>
        <li>
          We encourage all communication to be conducted within our online
          WhatsApp group community. If you have any concerns or questions,
          please do not hesitate to reach out to the coordinator directly. If,
          for any reason, you are not comfortable using WhatsApp or being a part
          of the WhatsApp group, we kindly request that you inform the
          coordinator at the time of admission.
        </li>
      </ul>
    ),
  },
  {
    heading: 'Specific Terms for Offline Students',
  },
  {
    heading: 'Hostel Rules',
    points: (
      <ul>
        <li>
          <b>Leaving and Returning Policy</b>
        </li>
        In the event that you need to leave the Institute for any reason, please
        ensure you have obtained prior permission from your course coordinator.
        Additionally, upon your return, please ensure that you are back on
        campus by 9:00 p.m.
        <li>
          <b>Lights Out and Activity Curfew</b>
        </li>
        We kindly request that all lights be turned off and activities cease by
        10:00 p.m. This will help you in feeling energised and refreshed the
        following day.
        <li>
          <b>Substance Use Policy</b>
        </li>
        It is strictly prohibited to carry and consume any of the substances
        like tobacco, alcohol or illicit drugs on the campus.
        <li>
          <b>Visitation between Students of Opposite Sex.</b>
        </li>
        We uphold a policy where students of opposite sexes are not permitted to
        enter each other’s hostel rooms. This policy is established to ensure
        the privacy, comfort, and security of all residents.
        <li>
          <b>Fostering a Serene Environment and Positive Conduct</b>
        </li>
        During your tenure here, we earnestly request that you cultivate an
        atmosphere characterized by tranquillity and serenity, conducive to the
        practice of yoga. Simultaneously, maintain the sanctity of the institute
        through positive and respectful behaviour.
        <li>
          <b>Property Maintenance</b>
        </li>
        Students are expected to maintain the Institute’s property in good
        condition. If any damage occurs, the student will be responsible for
        bearing the associated costs.
        <li>
          <b>Shared Accommodation:</b>
        </li>
        Accommodation is provided on a shared basis. Kindly utilize the keys and
        locks provided by the hostel management for security. Take due care of
        your personal belongings and valuables; the institute is not liable for
        any losses.
        <li>
          <b>Cleanliness and Hygiene:</b>
        </li>
        It is essential to maintain cleanliness in your room, toilets, and
        common living areas.
        <li>
          <b>Bed Linen and Towels:</b>
        </li>
        Bed linen, including sheets, pillowcases, blankets, and mosquito nets,
        will be changed weekly, unless under emergency circumstances. Kindly
        bring your own towels.
        <li>
          <b>Laundry Services:</b>
        </li>
        Laundry services are outsourced and must be settled directly with the
        service provider. It’s important to note that the Institute serves
        solely as a facilitator for this service and holds no responsibility for
        any damage caused to the clothes. Alternatively, you have the option to
        wash your clothes in the bathroom and use the provided racks in every
        room for drying. This self-service option is available for your
        convenience.
        <li>
          <b>Inspections:</b>
        </li>
        Kindly be aware that your room or locker may be subject to inspection by
        the hostel caretaker at any time.
        <li>
          <b>Provision for Refrigeration Facility</b>
        </li>
        The primary function of our refrigeration facilities is to provide
        secure storage for medicines, as well as approved consumables such as
        fruits and salad ingredients. Each floor is equipped with a shared
        refrigerator for your use. You may store your food in it, but please
        remember to label your items and only consume what belongs to you.
      </ul>
    ),
  },
  {
    heading: 'Internet Usage Terms',
    points: (
      <ul>
        An internet-enabled computer is provided at the Institute, which may be
        used for email access with prior permission. Internet use during class
        hours is not permitted. The timing for internet access will be allocated
        by the Course Coordinator.
      </ul>
    ),
  },
  {
    heading: 'Dining Etiquette and Meal Protocol',
    points: (
      <ul>
        *Please Note: If you’re attending our courses, camps, or workshops with
        inclusive meal services, you can enjoy Sattvik food at Naivedyam. If you
        prefer eating Sattvik food that’s not included in your course, please
        let us know in advance. There’s an additional cost for this, and we’ll
        be happy to arrange it for you.
      </ul>
    ),
  },
  {
    heading: 'Nutritious Sattvik Dining',
    points: (
      <ul>
        We encourage students to partake in the highly nutritious sattvik food
        served within our dining hall at “Naivedyam”.
      </ul>
    ),
  },
  {
    heading: 'Scheduled Meal Times',
    points: (
      <ul>
        To ensure an organized dining experience, we kindly request that all
        meals be enjoyed during the designated meal times.
        <ul>Breakfast - 8.00 a.m. to 9.00 a.m.</ul>
        <ul>Lunch - 12.00 noon to 1:00 p.m.</ul>
        <ul>Tea and snacks - 4.00 p.m. to 5.00 p.m.</ul>
        <ul>Dinner - 7.30 p.m. to 8.30 p.m.</ul>
        <li>
          <b>Restrictions on Outside Food</b>
        </li>
        No outside food to be brought into the dining hall.
        <li>
          <b>Silent Dining Environment</b>
        </li>
        To create a tranquil and focused dining environment, we maintain a
        policy prohibiting talking during meals. Practice “mauna”, be mindful
        and engage all your five senses while eating.
        <li>
          <b>Meal Absence Notification</b>
        </li>
        In situations where you will not be partaking in a meal or meals on a
        particular day, we request that you inform the office, the kitchen
        department, and your course coordinator in writing.
      </ul>
    ),
  },
  {
    heading: 'Respectful Interaction with Institute Staff',
    points: (
      <ul>
        <li>
          <b>Courteous Treatment of Staff</b>
        </li>
        We kindly request that all individuals treat our staff, including
        housekeeping personnel, with the utmost courtesy and respect at all
        times. This practice fosters an atmosphere of mutual regard and
        professionalism.
        <li>
          <b>Housekeeping Services</b>
        </li>
        Please be advised that our housekeeping staff is here to maintain the
        cleanliness and orderliness of our facilities. As such, their services
        are not to be engaged for personal or private tasks.
        <li>
          <b>No Tipping</b>
        </li>
        In adherence to our Institutional policy, we ask that you refrain from
        offering tips in cash or kind to any members of our staff.
      </ul>
    ),
  },
  {
    heading: 'Courier Services Protocol',
    points: (
      <ul>
        <li>
          Please inform our reception in advance regarding expected parcels.
          Kindly retrieve your courier parcels at the main gate of our premises.
          To maintain security, courier personnel are not allowed inside the
          premises. Upon receipt, take a moment to verify the contents of your
          courier parcel to ensure order accuracy and delivery integrity.
        </li>
      </ul>
    ),
  },


]
export default data
